import { lazy } from "react";

export default {
	NotFound: lazy(() => import('pages/Home')),
	Home: lazy(() => import('pages/Home')),
}
